import { Directive, Input, HostBinding } from '@angular/core';
import { BaseDirective } from '../base/_base.directive';

@Directive({
  selector: 'bs-badge, [bsBadge]',
  exportAs: 'bs-badge'
})
export class BadgeDirective extends BaseDirective {

  // ['default', 'primary', 'success', 'info', 'warning', danger]
  // https://v4-alpha.getbootstrap.com/components/badge/#contextual-variations
  @Input() set badgeVariation(variation: string) {
    this.setClassName(`badge-${variation}`);
  }

  @HostBinding('class.badge') badgeClass: boolean = true;

  @HostBinding('class.badge-pill') badgePillClass: boolean = true;

}
